export default {
    hostname: 'https://api.sibugol.com'
}
